var _style, _desc, _g, _g2, _defs, _path, _g3, _defs2, _path2, _g4, _defs3, _path3, _path4, _g5, _defs4, _path5, _g6, _defs5, _path6, _path7, _defs6, _path8, _path9, _g7, _defs7, _path10, _path11, _defs8, _path12, _g8, _g9, _g10, _g11, _g12, _defs9, _rect, _g13, _defs10, _path13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217 237",
    style: {
      enableBackground: "new 0 0 217 237"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#972DC2;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{mask:url(#mask-2_00000157993429256986199620000007669569060356141187_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#8A4CA8;}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter_00000013887635068319131210000009236719388540009632_);}\n\t.st6{mask:url(#mask-4_00000108289489904726595190000005620939794341568650_);}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#D0C6AC;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000134252013893936368060000001231043642838325918_);}\n\t.st9{mask:url(#mask-6_00000145748085600128245620000014291584988729518516_);}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#CC894C;}\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_00000082366433801576261760000001405584254650872448_);}\n\t\n\t\t.st12{mask:url(#mask-6_00000121259307442839838210000010329046307554568895_);fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#B7C1DB;}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_00000054259653754214188690000018337641073233782183_);}\n\t.st15{mask:url(#mask-8_00000109748098421060741430000012739097236102050207_);}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#293347;}\n\t.st17{filter:url(#Adobe_OpacityMaskFilter_00000103237280783364603860000006337254503151809425_);}\n\t.st18{mask:url(#mask-8_00000160187575449666375500000018154802851935987330_);fill-rule:evenodd;clip-rule:evenodd;fill:#F4F4F4;}\n\t.st19{filter:url(#Adobe_OpacityMaskFilter_00000083051669604904344900000003570183391070472860_);}\n\t\n\t\t.st20{mask:url(#mask-8_00000047775859939699565360000001157957762362678435_);fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.16;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.7;}\n\t.st22{filter:url(#Adobe_OpacityMaskFilter_00000161602019094561094420000010544899971692503477_);}\n\t.st23{mask:url(#mask-10_00000032624683444776306850000016855508606088212873_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000035514506145945244630000007963951470441865601_);}\n\t.st25{mask:url(#mask-10_00000129921740994049506800000003860109884388806075_);}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#FF4F6D;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.16;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.6;}\n\t.st29{filter:url(#Adobe_OpacityMaskFilter_00000167379400859220380120000013267553166741991049_);}\n\t.st30{mask:url(#mask-12_00000038385299464872061800000010692908932051768734_);}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#1F3140;}\n\t.st32{filter:url(#Adobe_OpacityMaskFilter_00000094607466114301283690000012768754107554796205_);}\n\t.st33{mask:url(#mask-14_00000147200097485690183100000008600003341455084976_);}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#4A312C;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Website"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mf-avatar",
    transform: "translate(-10.000000, -15.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(10.800000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Background"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1_00000166657475327070390350000010317677622829785000_",
    className: "st0",
    cx: 108,
    cy: 108,
    r: 108
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 216.4,
    height: 216
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 216.4,
    height: 216,
    id: "mask-2_00000157993429256986199620000007669569060356141187_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "path-1_00000132081608734479767860000005735773454149883057_",
    className: "st2",
    cx: 108,
    cy: 108,
    r: 108
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_xD83D__xDD8D_-Circle-Color",
    className: "st3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_xD83D__xDD8D_Color",
    x: 0,
    className: "st4",
    width: 216.4,
    height: 216
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000054964639311037499530000015443634394820171188_",
    filterUnits: "userSpaceOnUse",
    x: -0.1,
    y: 0,
    width: 239.1,
    height: 252.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.1,
    y: 0,
    width: 239.1,
    height: 252.8,
    id: "mask-4_00000108289489904726595190000005620939794341568650_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000054964639311037499530000015443634394820171188_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path-3_00000027597687391288787390000009430680394327544712_",
    className: "st2",
    d: "M0,144V0h237.6v144h-10.8 c0,59.6-48.4,108-108,108s-108-48.4-108-108l0,0H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(28.800000, 32.400000)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-5_00000129922336572166380410000002031408651826203536_",
    className: "st7",
    d: "M90,0c27.8,0,50.4,22.6,50.4,50.4l0,5.5 c5.1,0.9,9,5.3,9,10.7v12.6c0,5.4-4,10-9.3,10.7c-1.9,17.8-13,32.9-28.5,40.3l0,16.6h3.6c35.8,0,64.8,29,64.8,64.8v8.1H0v-8.1 c0-35.8,29-64.8,64.8-64.8h3.6l0-16.6c-15.5-7.4-26.7-22.4-28.5-40.3c-5.2-0.7-9.3-5.2-9.3-10.7V66.6c0-5.4,3.9-9.8,9-10.7 l0-5.5C39.6,22.6,62.2,0,90,0z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000096778414795126179240000006284748402916036741_",
    filterUnits: "userSpaceOnUse",
    x: -28.8,
    y: 0,
    width: 238.4,
    height: 220.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -28.8,
    y: 0,
    width: 238.4,
    height: 220.4,
    id: "mask-6_00000145748085600128245620000014291584988729518516_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000096778414795126179240000006284748402916036741_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path-5_00000072974286116261593380000015963854927193653123_",
    className: "st2",
    d: "M90,0c27.8,0,50.4,22.6,50.4,50.4 l0,5.5c5.1,0.9,9,5.3,9,10.7v12.6c0,5.4-4,10-9.3,10.7c-1.9,17.8-13,32.9-28.5,40.3l0,16.6h3.6c35.8,0,64.8,29,64.8,64.8v8.1 H0v-8.1c0-35.8,29-64.8,64.8-64.8h3.6l0-16.6c-15.5-7.4-26.7-22.4-28.5-40.3c-5.2-0.7-9.3-5.2-9.3-10.7V66.6 c0-5.4,3.9-9.8,9-10.7l0-5.5C39.6,22.6,62.2,0,90,0z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Skin_x2F__xD83D__xDC76__xD83C__xDFFB_-05-Pale",
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-28.800000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st10",
    width: 238.4,
    height: 220.4
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000018930080099107804890000003304103188068823224_",
    filterUnits: "userSpaceOnUse",
    x: 39.6,
    y: 84.6,
    width: 100.8,
    height: 57.6
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 39.6,
    y: 84.6,
    width: 100.8,
    height: 57.6,
    id: "mask-6_00000121259307442839838210000010329046307554568895_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000018930080099107804890000003304103188068823224_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path-5_00000023280596412843750160000017214648970834189501_",
    className: "st2",
    d: "M90,0c27.8,0,50.4,22.6,50.4,50.4 l0,5.5c5.1,0.9,9,5.3,9,10.7v12.6c0,5.4-4,10-9.3,10.7c-1.9,17.8-13,32.9-28.5,40.3l0,16.6h3.6c35.8,0,64.8,29,64.8,64.8v8.1 H0v-8.1c0-35.8,29-64.8,64.8-64.8h3.6l0-16.6c-15.5-7.4-26.7-22.4-28.5-40.3c-5.2-0.7-9.3-5.2-9.3-10.7V66.6 c0-5.4,3.9-9.8,9-10.7l0-5.5C39.6,22.6,62.2,0,90,0z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Neck-Shadow",
    className: "st12",
    d: "M39.6,84.6c0,27.8,22.6,50.4,50.4,50.4s50.4-22.6,50.4-50.4l0,0v7.2 c0,27.8-22.6,50.4-50.4,50.4s-50.4-22.6-50.4-50.4V84.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clothing_x2F_Hoodie",
    transform: "translate(0.000000, 153.000000)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Hoodie"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-7_00000128450850002693421500000004517081226479422340_",
    className: "st13",
    d: "M140.4,11.8 c16.3,1.8,28.8,6.8,28.8,19.8l0-0.4c23.3,9.8,39.6,32.9,39.6,59.7V99h-180v-8.1C28.8,64,45.1,41,68.4,31.2 c0.2-12.7,12.7-17.6,28.8-19.4l0,17c0,11.9,9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6l0,0L140.4,11.8z"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000130639330942835427310000013721683437531870890_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238.5,
    height: 99
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 238.5,
    height: 99,
    id: "mask-8_00000109748098421060741430000012739097236102050207_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000130639330942835427310000013721683437531870890_)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path-7_00000018920013736223829750000010565474267398483868_",
    className: "st2",
    d: "M140.4,11.8 c16.3,1.8,28.8,6.8,28.8,19.8l0-0.4c23.3,9.8,39.6,32.9,39.6,59.7V99h-180v-8.1C28.8,64,45.1,41,68.4,31.2 c0.2-12.7,12.7-17.6,28.8-19.4l0,17c0,11.9,9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6l0,0L140.4,11.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Color_x2F_Palette_x2F_Slate",
    className: "st15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_xD83D__xDD8D_Color_00000139256559346323732030000008930600312153824931_",
    className: "st16",
    width: 238.5,
    height: 99
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000046341574845953330280000002293247551794692796_",
    filterUnits: "userSpaceOnUse",
    x: 85.5,
    y: 52.3,
    width: 66.6,
    height: 46.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 85.5,
    y: 52.3,
    width: 66.6,
    height: 46.7,
    id: "mask-8_00000160187575449666375500000018154802851935987330_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000046341574845953330280000002293247551794692796_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path-7_00000012449809650320611170000001702252500238217903_",
    className: "st2",
    d: "M140.4,11.8 c16.3,1.8,28.8,6.8,28.8,19.8l0-0.4c23.3,9.8,39.6,32.9,39.6,59.7V99h-180v-8.1C28.8,64,45.1,41,68.4,31.2 c0.2-12.7,12.7-17.6,28.8-19.4l0,17c0,11.9,9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6l0,0L140.4,11.8z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Straps",
    className: "st18",
    d: "M91.8,55.6l0,43.4h-6.3l0-46.7C87.5,53.5,89.6,54.6,91.8,55.6z M152.1,52.3l0,36.3 c0,1.7-1.4,3.2-3.2,3.2s-3.1-1.4-3.1-3.2l0-33.1C148,54.6,150.1,53.5,152.1,52.3z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000055695669951497253740000014335647522645804451_",
    filterUnits: "userSpaceOnUse",
    x: 59,
    y: 11.5,
    width: 119.7,
    height: 49.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 11.5,
    width: 119.7,
    height: 49.7,
    id: "mask-8_00000047775859939699565360000001157957762362678435_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000055695669951497253740000014335647522645804451_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path-7_00000131339002256387678860000006653229722336763284_",
    className: "st2",
    d: "M140.4,11.8 c16.3,1.8,28.8,6.8,28.8,19.8l0-0.4c23.3,9.8,39.6,32.9,39.6,59.7V99h-180v-8.1C28.8,64,45.1,41,68.4,31.2 c0.2-12.7,12.7-17.6,28.8-19.4l0,17c0,11.9,9.7,21.6,21.6,21.6s21.6-9.7,21.6-21.6l0,0L140.4,11.8z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    className: "st20",
    d: "M155.7,11.5c13.5,2.6,22.9,7.7,22.9,17.6c0,17.7-29.7,32.1-59.8,32.1S59,46.8,59,29.1 c0-10,9.4-15.1,22.9-17.6c-8.2,3-13.5,8.1-13.5,16.5c0,18.4,25,33.2,50.4,33.2s50.4-14.9,50.4-33.2c0-8.3-5.1-13.3-13-16.3 L155.7,11.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(68.400000, 73.800000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth_x2F_Smile",
    transform: "translate(1.800000, 46.800000)"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Mouth"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9_00000123421209837368677160000014501016530747049357_",
    className: "st21",
    d: "M31.6,13.6c1,8.5,8.2,15.2,17,15.2 c8.8,0,16.1-6.7,17-15.3c0.1-0.7-0.7-1.8-1.7-1.8c-13.4,0-23.7,0-30.6,0C32.4,11.7,31.5,12.8,31.6,13.6z"
  }))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000108304628843343518580000012045441295366423975_",
    filterUnits: "userSpaceOnUse",
    x: 35.1,
    y: 1.8,
    width: 27.9,
    height: 14.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 35.1,
    y: 1.8,
    width: 27.9,
    height: 14.4,
    id: "mask-10_00000032624683444776306850000016855508606088212873_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000108304628843343518580000012045441295366423975_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path-9_00000000208111029349664400000016748571493025793974_",
    className: "st2",
    d: "M31.6,13.6c1,8.5,8.2,15.2,17,15.2 c8.8,0,16.1-6.7,17-15.3c0.1-0.7-0.7-1.8-1.7-1.8c-13.4,0-23.7,0-30.6,0C32.4,11.7,31.5,12.8,31.6,13.6z"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Teeth",
    className: "st23",
    d: "M39.6,1.8h18.9c2.5,0,4.5,2,4.5,4.5v5.4c0,2.5-2,4.5-4.5,4.5H39.6c-2.5,0-4.5-2-4.5-4.5V6.3 C35.1,3.8,37.1,1.8,39.6,1.8z"
  })), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000016041425090241891520000009888445659934256790_",
    filterUnits: "userSpaceOnUse",
    x: 34.2,
    y: 21.6,
    width: 28.8,
    height: 19.8
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 34.2,
    y: 21.6,
    width: 28.8,
    height: 19.8,
    id: "mask-10_00000129921740994049506800000003860109884388806075_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000016041425090241891520000009888445659934256790_)"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path-9_00000040556163605913504210000002300061175992249221_",
    className: "st2",
    d: "M31.6,13.6c1,8.5,8.2,15.2,17,15.2 c8.8,0,16.1-6.7,17-15.3c0.1-0.7-0.7-1.8-1.7-1.8c-13.4,0-23.7,0-30.6,0C32.4,11.7,31.5,12.8,31.6,13.6z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Tongue",
    className: "st25"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.200000, 21.600000)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 9.9,
    cy: 9.9,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 18.9,
    cy: 9.9,
    r: 9.9
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Nose_x2F_Default",
    transform: "translate(25.200000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    className: "st27",
    d: "M14.4,7.2c0,4,4.8,7.2,10.8,7.2l0,0c6,0,10.8-3.2,10.8-7.2"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Eyes_x2F_Happy-_xD83D__xDE01_",
    transform: "translate(0.000000, 7.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Squint",
    className: "st28",
    d: "M14.5,20.2c1.7-3.4,5.4-5.8,9.8-5.8c4.3,0,8.1,2.4,9.7,5.8c0.5,1-0.2,1.8-0.9,1.2 c-2.2-1.9-5.3-3.1-8.8-3.1c-3.4,0-6.4,1.1-8.6,2.9C14.9,21.9,14.1,21.2,14.5,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Squint_00000029765210103519802440000004568290112823739832_",
    className: "st28",
    d: "M66.7,20.2c1.7-3.4,5.4-5.8,9.8-5.8 c4.3,0,8.1,2.4,9.7,5.8c0.5,1-0.2,1.8-0.9,1.2c-2.2-1.9-5.3-3.1-8.8-3.1c-3.4,0-6.4,1.1-8.6,2.9C67.1,21.9,66.3,21.2,66.7,20.2 z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow_x2F_Natural_x2F_Default-Natural"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow",
    className: "st28",
    d: "M23.9,5.5c-5.2,0.2-13.7,4-13.5,9.3c0,0.2,0.3,0.2,0.4,0.1c2.5-2.7,20.1-5.4,26.3-3.9 c0.6,0.1,1-0.4,0.6-0.8C34.7,6.7,28.6,5.3,23.9,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Eyebrow_00000032614347240202325990000013794923794768858276_",
    className: "st28",
    d: "M77.8,5.5c5.2,0.2,13.7,4,13.5,9.3 c0,0.2-0.3,0.2-0.4,0.1c-2.5-2.7-20.1-5.4-26.3-3.9c-0.6,0.1-1-0.4-0.6-0.8C67,6.7,73.1,5.3,77.8,5.5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_00000109734680270157744540000006542030730463456949_"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000125561440832128796690000008263494537044502200_",
    filterUnits: "userSpaceOnUse",
    x: -0.1,
    y: 0,
    width: 239.1,
    height: 252.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -0.1,
    y: 0,
    width: 239.1,
    height: 252.4,
    id: "mask-12_00000038385299464872061800000010692908932051768734_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000125561440832128796690000008263494537044502200_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "path-11_00000031174121749382149390000004955905211038446998_",
    className: "st2",
    width: 237.6,
    height: 252
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.000000, 15.000000)"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Short-Hair"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-13_00000041991619614921201110000001648541390362707120_",
    className: "st31",
    d: "M118.1,20.9 c-2.5-2.5-5.4-4.7-8.2-6.9c-0.6-0.5-1.2-0.9-1.9-1.4c-0.1-0.1-1.5-1.1-1.7-1.5c-0.4-0.9-0.2-0.2-0.1-1.3 c0.1-1.3,2.8-5.2,0.8-6c-0.9-0.4-2.5,0.6-3.4,1c-1.7,0.7-3.4,1.2-5.2,1.7c0.8-1.7,2.4-5-0.6-4.1c-2.3,0.7-4.5,2.5-6.9,3.3 c0.8-1.3,3.9-5.2,1.1-5.5c-0.9-0.1-3.4,1.6-4.4,1.9c-2.8,1-5.7,1.7-8.7,2.3C69,6.3,57.2,5.8,47.9,10.4 c-7.2,3.5-14.3,9-18.4,16c-4,6.7-5.5,14.1-6.3,21.8c-0.6,5.7-0.7,11.5-0.4,17.2c0.1,1.9,0.3,10.4,3,7.8 c1.3-1.3,1.3-6.5,1.7-8.3c0.7-3.5,1.3-7.1,2.5-10.5c2-6,4.3-8.8,9.3-13c3.2-2.7,5.4-6.2,8.4-8.9c1.4-1.2,0.3-1.1,2.5-0.9 c1.5,0.1,3,0.1,4.4,0.2C58,32,61.4,32,64.8,32c6.9,0,13.7,0.1,20.6-0.2c3.1-0.2,6.1-0.2,9.2-0.5c1.7-0.2,4.7-1.2,6.1-0.4 c1.3,0.8,2.6,3.3,3.5,4.3c2.2,2.4,4.8,4.3,7.3,6.2c5.3,4.1,8,5.7,9.6,12.1c1.6,6.4,1.2,12.4,3.1,18.7c0.3,1.1,1.3,3,2.4,1.3 c0.2-0.3,0.2-2.1,0.2-3.1c0-4.1,1-7.1,1-11.2C127.8,46.7,127.4,30.4,118.1,20.9z"
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000013878208787074197330000008648473997012022437_",
    filterUnits: "userSpaceOnUse",
    x: -43.1,
    y: -15,
    width: 239.1,
    height: 252.4
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -43.1,
    y: -15,
    width: 239.1,
    height: 252.4,
    id: "mask-14_00000147200097485690183100000008600003341455084976_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000013878208787074197330000008648473997012022437_)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path-13_00000142882237113334751580000003968762205662900145_",
    className: "st2",
    d: "M118.1,20.9 c-2.5-2.5-5.4-4.7-8.2-6.9c-0.6-0.5-1.2-0.9-1.9-1.4c-0.1-0.1-1.5-1.1-1.7-1.5c-0.4-0.9-0.2-0.2-0.1-1.3 c0.1-1.3,2.8-5.2,0.8-6c-0.9-0.4-2.5,0.6-3.4,1c-1.7,0.7-3.4,1.2-5.2,1.7c0.8-1.7,2.4-5-0.6-4.1c-2.3,0.7-4.5,2.5-6.9,3.3 c0.8-1.3,3.9-5.2,1.1-5.5c-0.9-0.1-3.4,1.6-4.4,1.9c-2.8,1-5.7,1.7-8.7,2.3C69,6.3,57.2,5.8,47.9,10.4 c-7.2,3.5-14.3,9-18.4,16c-4,6.7-5.5,14.1-6.3,21.8c-0.6,5.7-0.7,11.5-0.4,17.2c0.1,1.9,0.3,10.4,3,7.8 c1.3-1.3,1.3-6.5,1.7-8.3c0.7-3.5,1.3-7.1,2.5-10.5c2-6,4.3-8.8,9.3-13c3.2-2.7,5.4-6.2,8.4-8.9c1.4-1.2,0.3-1.1,2.5-0.9 c1.5,0.1,3,0.1,4.4,0.2C58,32,61.4,32,64.8,32c6.9,0,13.7,0.1,20.6-0.2c3.1-0.2,6.1-0.2,9.2-0.5c1.7-0.2,4.7-1.2,6.1-0.4 c1.3,0.8,2.6,3.3,3.5,4.3c2.2,2.4,4.8,4.3,7.3,6.2c5.3,4.1,8,5.7,9.6,12.1c1.6,6.4,1.2,12.4,3.1,18.7c0.3,1.1,1.3,3,2.4,1.3 c0.2-0.3,0.2-2.1,0.2-3.1c0-4.1,1-7.1,1-11.2C127.8,46.7,127.4,30.4,118.1,20.9z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Color_x2F_Hair_x2F_Brown-Dark",
    className: "st33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_00000128468863891803974900000004662622101726908300_",
    transform: "translate(-43.100000, -15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st34",
    width: 239.1,
    height: 252.4
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.5bcf7bf9664083baa67cfe312337da5f.svg";
export { ForwardRef as ReactComponent };